<template>
  <FloatingCard class="stack stack--small" :feeling="feeling">
    <template v-if="status === 'checking-button'">
      <p>Zjišťuji, jestli už je vytvořené tlačítko ve Flexi.</p>
    </template>
    <template v-else-if="status === 'button-exists'">
      <p>
        Tlačítko ve Flexi už je vytvořené.
        Můžete ho <a href="/" @click.prevent="deleteButton">smazat</a>.
      </p>
    </template>
    <template v-else-if="status === 'button-created'">
      <p>Tlačítko ve Flexi vytvořeno. Můžete ho
        <a href="/" @click.prevent="deleteButton">smazat</a>.</p>
    </template>
    <template v-else-if="status === 'deleting-button'">
      <p>Mažu tlačítko.</p>
    </template>
    <template v-else-if="status === 'something-wrong'">
      <p>Něco se pokazilo, ozvěte se nám prosím.</p>
    </template>
    <template v-else>
      <template v-if="status === 'button-missing'">
        <p>Je potřeba vytvořit tlačítko ve Flexi.</p>
      </template>
      <template v-else-if="status === 'creating-button'">
        <p>Vytvářím tlačítko.</p>
      </template>
      <template v-else-if="status === 'button-deleted'">
        <p>Tlačítko smazáno.</p>
      </template>
      <ButtonComponent label="Vytvořit" @click="createButton" />
    </template>
  </FloatingCard>
</template>

<script>
import ButtonComponent from '@/components/ButtonComponent';
import FloatingCard from '@/components/FloatingCard';

import Flexi from '@/mixins/Flexi';

export default {
  name: 'FlexiButtonsSetupCard',
  components: {
    ButtonComponent,
    FloatingCard,
  },
  mixins: [
    Flexi,
  ],
  props: {
    apiURL: {
      type: String,
    },
    username: {
      type: String,
    },
    password: {
      type: String,
    },
    token: {
      type: String,
    },
    company: {
      type: String,
    },
    buttons: {
      type: Array,
    },
  },
  data() {
    return {
      status: null,
    };
  },
  computed: {
    feeling() {
      switch (this.status) {
        case 'checking-button':
          return 'pending';
        case 'button-exists':
          return 'positive';
        case 'button-missing':
          return null;
        case 'creating-button':
          return 'pending';
        case 'button-created':
          return 'positive';
        case 'deleting-button':
          return 'pending';
        case 'button-deleted':
          return null;
        case 'something-wrong':
          return 'negative';
        default:
          return null;
      }
    },
  },
  watch: {
    status() {
      this.$emit('status-change', { status: this.status, data: this.$data });
    },
    company() {
      this.checkButton();
    },
  },
  methods: {
    async checkButton() {
      try {
        this.status = 'checking-button';
        if (await this.$_Flexi_checkButton({
          apiURL: this.apiURL,
          username: this.username,
          password: this.password,
          token: this.token,
          company: this.company,
          button: this.buttons[0],
        })) {
          this.status = 'button-exists';
        } else {
          this.status = 'button-missing';
        }
      } catch (error) {
        this.status = 'something-wrong';
        throw error;
      }
    },
    async createButton() {
      try {
        this.status = 'creating-button';
        await this.$_Flexi_createButton({
          apiURL: this.apiURL,
          username: this.username,
          password: this.password,
          token: this.token,
          company: this.company,
          button: this.buttons[0],
        });
        this.status = 'button-created';
      } catch (error) {
        this.status = 'something-wrong';
        throw error;
      }
    },
    async deleteButton() {
      try {
        this.status = 'deleting-button';
        await this.$_Flexi_deleteButton({
          apiURL: this.apiURL,
          username: this.username,
          password: this.password,
          token: this.token,
          company: this.company,
          button: this.buttons[0],
        });
        this.status = 'button-deleted';
      } catch (error) {
        this.status = 'something-wrong';
        throw error;
      }
    },
  },
  mounted() {
    this.checkButton();
  },
};
</script>
